module.exports = __webpack_public_path__ + "img/close.d88cdb3.svg";